export const normalizeString = (str: string) => {
    return str
        .normalize("NFD") // Normaliza para decompor caracteres acentuados
        .replace(/[\u0300-\u036f]/g, "") // Remove os acentos
        .replace(/[^a-zA-Z0-9\s]/g, "") // Remove pontuações
        .toLowerCase(); // Converte para minúsculas
};